// functions/src/games/copyGame.ts
export const copyGame = (firebase, body) => {
  const call = firebase.call('copyGame');
  return call(body);
};
// functions/src/admins/createAdmin.ts
export const createAdmin = (firebase, body) => {
  const call = firebase.call('createAdmin');
  return call(body);
};
// functions/src/events/createEvent.ts
export const createEvent = (firebase, body) => {
  const call = firebase.call('createEvent');
  return call(body);
};
// functions/src/games/createGame.ts
export const createGame = (firebase, body) => {
  const call = firebase.call('createGame');
  return call(body);
};
// functions/src/questions/createQuestion.ts
export const createQuestion = (firebase, body) => {
  const call = firebase.call('createQuestion');
  return call(body);
};
// functions/src/events/deleteEvent.ts
export const deleteEvent = (firebase, uid) => {
  const call = firebase.call('deleteEvent');
  return call(uid);
};
// functions/src/games/deleteGame.ts
export const deleteGame = (firebase, uid) => {
  const call = firebase.call('deleteGame');
  return call(uid);
};
// functions/src/admins/deleteUser.ts
export const deleteUser = (firebase, body) => {
  const call = firebase.call('deleteUser');
  return call(body);
};
// functions/src/games/disownGame.ts
export const disownGame = (firebase, id) => {
  const call = firebase.call('disownGame');
  return call({ gameId: id });
};
// functions/src/events/endEvent.ts
export const endEvent = (firebase, eventId) => {
  const call = firebase.call('endEvent');
  return call({ eventId: eventId });
};
// functions/src/admins/extendCreatorTrial.ts
export const extendCreatorTrial = (firebase, body) => {
  const call = firebase.call('extendCreatorTrial');
  return call(body);
};
// functions/src/admins/fetchCreator.ts
export const fetchCreator = (firebase, body) => {
  const call = firebase.call('fetchCreator');
  return call(body);
};
// functions/src/admins/fetchCreatorList.ts
export const fetchCreatorList = (firebase) => {
  const call = firebase.call('fetchCreatorList');
  return call();
};
// functions/src/scoreboard/fetchScoreboard.ts
export const fetchScoreboard = (firebase, body) => {
  const call = firebase.call('fetchScoreboard');
  return call(body);
};
// functions/src/statistics/fetchStatistics.ts
export const fetchStatistics = (firebase) => {
  const call = firebase.call('fetchStatistics');
  return call();
};
// functions/src/admins/freezeCreatorAccess.ts
export const freezeCreatorAccess = (firebase, body) => {
  const call = firebase.call('freezeCreatorAccess');
  return call(body);
};
// functions/src/authentication/enhancedSignIn.ts
export const loginWeb = (firebase) => {
  const call = firebase.call('loginWeb');
  return call();
};
// functions/src/admins/registerCreator.ts
export const registerCreator = (firebase, body) => {
  const call = firebase.call('registerCreator');
  return call(body);
};
// functions/src/games/shareGame.ts
export const shareGame = (firebase, body) => {
  const call = firebase.call('shareGame');
  return call(body);
};
// functions/src/admins/updateCreator.ts
export const updateCreator = (firebase, body) => {
  const call = firebase.call('updateCreator');
  return call(body);
};
// functions/src/events/updateEvent.ts
export const updateEvent = (firebase, body) => {
  const call = firebase.call('updateEvent');
  return call(body);
};
// functions/src/games/updateGame.ts
export const updateGame = (firebase, body) => {
  const call = firebase.call('updateGame');
  return call(body);
};
// functions/src/admins/verifyCreator.ts
export const verifyCreator = (firebase, body) => {
  const call = firebase.call('verifyCreator');
  return call(body);
};
